// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const DownloadIcon = (props: IconProps) => (
  <Icon viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M12.7866 12.9204L15.6699 15.7704C15.8722 15.9704 16.1757 15.9704 16.3781 15.7704L19.2866 12.9204"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.0254 15.7249V7.97485" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M20.979 16.0083V18.7583C20.979 19.4583 20.429 20.0083 19.729 20.0083H12.229C11.529 20.0083 10.979 19.4583 10.979 18.7583V16.0083"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter id="filter0_d_361_6498" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_361_6498" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_361_6498" result="shape" />
      </filter>
    </defs>
  </Icon>
);
